import { FC, LegacyRef, forwardRef, useState, createElement } from 'react'
import { Collapse, List, ListItem } from '@maas-components/core'
import { ExpandLess, ExpandMore } from '@maas-components/icons'
import Link from '@material-ui/core/Link'
import Tooltip from '@material-ui/core/Tooltip'
import { NavLink } from 'react-router-dom'
import useStyles from './style'
import { TLinks, IMenu } from './types'

interface MenuLinksProps {
  menu: IMenu
  onClickMenuItem?: (item: TLinks) => void
  handleCloseOnClick?: () => void
}

const MenuLinks: FC<MenuLinksProps> = ({ menu, onClickMenuItem, handleCloseOnClick }) => {
  const classes = useStyles()

  const [open, setOpen] = useState(true)

  const handleClick = () => {
    setOpen(!open)
  }

  const TextToolTip = forwardRef(function TextToolTip(
    { text }: { text: string },
    ref: LegacyRef<HTMLDivElement>
  ) {
    return (
      <div ref={ref} className={classes.menuLinkName}>
        {text}
      </div>
    )
  })

  const renderMenuIcon = (icon: string) => {
    if (!icon) {
      return null
    }

    return createElement(icon, { className: classes.menuLinkIcon })
  }

  const renderMenuLink = (link: TLinks) => {
    return (
      <>
        {renderMenuIcon(link.icon)}
        <Tooltip title={link.name}>
          <TextToolTip text={link.name} />
        </Tooltip>
      </>
    )
  }

  return (
    <div>
      {menu.links.map((link, index) => {
        let linkElement

        switch (true) {
          case Boolean(link.target):
            linkElement = (
              <Link
                href={link.url}
                target={link.target}
                key={link.name + index}
                className={classes.menuLink}
              >
                {renderMenuLink(link)}
              </Link>
            )
            break
          case Boolean(onClickMenuItem):
            linkElement = (
              <Link
                href="#"
                key={link.name + index}
                className={classes.menuLink}
                onClick={e => {
                  e.preventDefault()
                }}
              >
                {renderMenuLink(link)}
              </Link>
            )
            break
          case Boolean(link.links):
            linkElement = (
              <div key={`parent_${link.name}_${index}`}>
                <ListItem button onClick={handleClick} className={classes.menuLink}>
                  {renderMenuLink(link)}
                  {open ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse
                  in={open}
                  timeout="auto"
                  unmountOnExit
                  key={`collapse_${link.name}_${index}`}
                >
                  <List component="div" disablePadding>
                    {link.links?.map((subLink, index) => (
                      <ListItem
                        button
                        className={classes.nested}
                        key={`child_${subLink.name}_${index}`}
                      >
                        <Link
                          href={subLink.url}
                          className={classes.subMenuLink}
                          key={subLink.name + index}
                        >
                          <span className={classes.menuLinkBall} />
                          {!(index === (link.links?.length ?? 0) - 1) && (
                            <div className={classes.menuLinkSymbol} />
                          )}
                          <Tooltip title={subLink.name}>
                            <TextToolTip text={subLink.name} />
                          </Tooltip>
                        </Link>
                      </ListItem>
                    ))}
                  </List>
                </Collapse>
              </div>
            )
            break
          default:
            linkElement = (
              <NavLink
                onClick={handleCloseOnClick}
                exact
                to={link.url}
                className={classes.menuLink}
                key={link.name + index}
              >
                {renderMenuLink(link)}
              </NavLink>
            )
            break
        }

        return linkElement
      })}
    </div>
  )
}

export default MenuLinks
